import { render, staticRenderFns } from "./LeccionE3.vue?vue&type=template&id=fdd2f436&"
import script from "./LeccionE3.vue?vue&type=script&lang=js&"
export * from "./LeccionE3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports